module.exports = __webpack_public_path__ + "img/碘元素作用01.0bb85ece.webp";